import React from "react";

const styleOptions = [
  "慈愛の賢者",
  "陽気な道化師",
  "深淵の思想家",
  "禅の老師",
  "ランダム"
];

export default function StyleSelector({ value, onChange }) {
  return (
    <div style={{ marginTop: "20px" }}>
      <label style={{ fontWeight: "bold", marginBottom: "8px", display: "block" }}>
        語り口を選ぶ
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          padding: "8px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          width: "100%"
        }}
      >
        {styleOptions.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}
